module.exports = __webpack_public_path__ + "static/media/payrollSimply.e2ee794d.png";